import { SafelySetInnerHTML } from "@faire/web--source/common/SafelySetInnerHTML";
import { Typography } from "@faire/web--source/slate/Typography";
import { Props as TypographyProps } from "@faire/web--source/slate/Typography/Typography";
import React from "react";

import { BuilderAttributes } from "./BuilderTypes";

export const BuilderTypography = ({
  textContent,
  attributes,
  ...props
}: TypographyProps & {
  textContent: string;
  attributes: BuilderAttributes;
}) => (
  <Typography
    {...props}
    style={attributes.style}
    className={attributes.className}
    key={attributes.key}
    builder-id={attributes["builder-id"]}
  >
    <SafelySetInnerHTML html={textContent} />
  </Typography>
);
